// extracted by mini-css-extract-plugin
export var active = "_l8-e";
export var blink = "_l8-f";
export var dropDownSelector = "_l8-5";
export var dropDownWrapper = "_l8-4";
export var fakeCursor = "_l8-d";
export var fontSizeButton = "_l8-7";
export var formQuillEditor = "_l8-0";
export var pressed = "_l8-g";
export var qlBlank = "_l8-1";
export var textFormattingToolbar = "_l8-2";
export var textFormattingToolbarClosed = "_l8-3";
export var textFormattingToolbarInline = "_l8-6";
export var textToolbarOption = "_l8-8";
export var toolbarCell = "_l8-a";
export var toolbarCellCollapsed = "_l8-b";
export var toolbarOptionHitArea = "_l8-c";
export var toolbarOverflow = "_l8-9";